import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { Col, Form, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../function/helper";

export default function SendBarcode({ barcode, setBarcode }) {
  const successRef = useRef(null);
  const failRef = useRef(null);

  const { mutate, isPending } = useMutation({
    mutationKey: ["sendScannedBarcode"],
    mutationFn: () =>
      postRequestByAuth("/digikala/v1/changeTotalPostStatus", { barcode }).then(
        res => {
          if (res && res.status === 200) {
            Swal.fire({
              icon: "success",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1000,
              timerProgressBar: true,
            });

            successRef.current?.play();
            return;
          }

          Swal.fire({
            icon: "error",
            text: res.message,
            showConfirmButton: false,
            timer: 1000,
            timerProgressBar: true,
          });

          failRef.current?.play();
        }
      ),
  });

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (barcode.length > 10) {
        mutate();
      }
    }, 500);

    return () => clearTimeout(timeOut);
  }, [barcode]);

  return (
    <Col
      xs={12}
      sm={8}
      md={6}
      xl={4}
      className="mx-auto pt-4 pb-2 position-relative"
    >
      <Form.Label>بارکد:</Form.Label>
      <Form.Control
        value={barcode}
        disabled={isPending}
        name="barcode"
        onChange={e => setBarcode(e.target.value)}
      />

      {isPending && (
        <span
          className="position-absolute"
          style={{ bottom: "0.5rem", left: "0.5rem" }}
        >
          <Spinner
            style={{
              fontSize: "0.8rem",
              width: 26,
              height: 26,
              color: "#898c8fff",
            }}
          />
        </span>
      )}

      <audio ref={successRef} src="/sounds/success.mp3" />
      <audio ref={failRef} src="/sounds/fail.mp3" />
    </Col>
  );
}
